<template>
	<div class="user-management wrapper">
		<div class="content-page">
			<div class="content">
				<div class="row" style="margin-bottom: 20px;">
					<div class="col-xl-6">用户管理</div>
					<div class="col-xl-6 breadcrumb1"><Breadcrumb></Breadcrumb></div>
				</div>
				<el-row>
					<el-form ref="form" :model="params" label-width="60px">
						<el-col :span="6">
							<el-form-item label="用户名"><el-input placeholder="用户名" size="medium" v-model="params.username"></el-input></el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="姓名"><el-input placeholder="姓名" size="medium" v-model="params.realName"></el-input></el-form-item>
						</el-col>
						<!-- <el-col :span="5">
              <el-form-item label="区域">
                <el-cascader v-model="params.region" :show-all-levels="false" @change="areaChange" size="medium" :options="options" :props="{ checkStrictly: false, label: 'name', value: 'id' }" clearable></el-cascader>
              </el-form-item>
            </el-col> -->
						<el-col :span="6">
							<el-form-item label="单位">
								<!-- <el-select v-model="params.unitId" size="medium" :disabled="unitOptions.length===0" clearable filterable placeholder="请选择">
                  <el-option v-for="item in unitOptions" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
                </el-select> -->
								<el-input size="medium" placeholder="请输入单位名称" v-model="params.unitName"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<div class="btn-wrap">
								<el-button size="medium" style="margin-left: 10px;" @click="queryUser">查询</el-button>
								<el-button size="medium" type="primary" icon="el-icon-edit" @click="addUser">新建用户</el-button>
							</div>
						</el-col>
					</el-form>
				</el-row>

				<el-card>
					<div class="explain">
						<!-- <span>说明：</span>
            点击人员，可对所选人员进行角色分配 -->
					</div>

					<el-table :header-cell-style="tableHeaderStyle" v-loading="loading" :data="tableData" border style="width: 100%">
						<el-table-column prop="realName" label="姓名" min-width="80"></el-table-column>
						<el-table-column prop="username" label="用户名" min-width="50"></el-table-column>
						<el-table-column prop="sex" label="性别" width="50">
							<template slot-scope="scope">{{ scope.row.sex===0?'女':scope.row.sex===1?'男':'' }}	</template>
						</el-table-column>
						<el-table-column prop="unitName" label="单位" min-width="80"></el-table-column>
						<!-- <el-table-column prop="email" label="Email" width="150"></el-table-column> -->
						<el-table-column prop="roleNames" label="角色" min-width="100">
							<template slot-scope="scope">{{ scope.row.roleNames.join('、') }}</template>
						</el-table-column>
						<el-table-column label="状态" width="70">
							<template slot-scope="scope">{{ scope.row.status == 1 ? '可用' : '不可用' }}	</template>
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button size="medium" type="text" @click="goEditUserPage(scope.row.id)">修改</el-button>
								<el-popconfirm style="margin-left:10px" title="确定删除吗？" @confirm="delConfirm(scope.row.id)">
									<el-button slot="reference" size="medium" type="text">删除</el-button>
								</el-popconfirm>
							</template>
						</el-table-column>
					</el-table>

					<el-pagination
						style="margin-top: 20px;"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="params.pageNumber"
						:page-sizes="[20, 50, 100]"
						:page-size="params.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumb from '../../components/Breadcrumb.vue';
import { getUserList, getAreaTree, delUser, getUnitListByArea } from '@/api/after/systemManagement.js';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			tableHeaderStyle: {
				backgroundColor: '#3083c5',
				color: '#fff'
			},
			options: [],
			tableData: [],
			params: {
				pageNumber: 1,
				pageSize: 20,
				pageSorts: [
					{
						asc: true,
						column: ''
					}
				],
				realName: '',
				region: '',
				unitId: '',
				unitName: '',
				username: ''
			},
			total: 0,
			unitOptions: [], //单位列表
			loading: false
		};
	},
	created() {
		this.getUserList();
		this.getAreaTree();
	},
	methods: {
		// 根据区域ID获取单位列表
		async getUnitListByArea(id) {
			const res = await getUnitListByArea(id);
			if (res.code == 200) {
				this.unitOptions = res.data;
			} else {
				this.$message.error(res.msg);
			}
		},
		// 修改用户
		goEditUserPage(id) {
			this.$router.push({ path: '/backstage/addUser', query: { id } });
		},
		// 是否确认删除用户
		delConfirm(id) {
			this.delUser(id);
		},
		// 删除用户
		async delUser(id) {
			const res = await delUser(id);
			if (res.code == 200) {
				this.getUserList();
			} else {
				this.$message.error(res.data);
			}
		},
		// 区域改变
		areaChange(val) {
			console.log(val);
			if (val.length === 0) {
				return;
			}
			let areaId = val[val.length - 1];
			this.getUnitListByArea(areaId);
		},
		// 获取用户列表
		async getUserList() {
			this.loading = true
			const res = await getUserList(this.params);
			console.log('用户列表', res);
			if (res.code == 200) {
				this.tableData = res.data.records;
				this.total = res.data.total;
				this.loading = false
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取区域树结构
		async getAreaTree() {
			const res = await getAreaTree();
			if (res.code == 200) {
				console.log('区域树', res);
				this.options = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		handleSizeChange(val) {
			this.params.pageSize = val;
			this.getUserList()
		},
		handleCurrentChange(val) {
			this.params.pageNumber = val;
			this.getUserList()
		},
		// 查询用户
		queryUser() {
			this.params.pageNumber = 1;
			// this.params.region = this.params.region[this.params.region.length - 1];
			console.log(this.params);
			this.getUserList();
		},
		addUser() {
			this.$router.push('/backstage/addUser');
		}
	}
};
</script>

<style scoped lang="scss">
.explain {
	font-size: 14px;
	border-bottom: 1px solid #eee;
	margin-bottom: 20px;
	line-height: 36px;
	color: #666666;
	span {
		font-weight: bold;
	}
}
.breadcrumb1 {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
</style>
